import { Injectable } from '@angular/core';
import { DbService } from '../db/db.service';
import { Clients } from 'src/app/models/firebase/client';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {
    constructor(
        private dbService: DbService,
    ) { }

    async getClients(projectId: string){
        let clients: Clients[] = [];
        const data = await this.dbService.firestore.collection('projects').doc(projectId).collection(Clients.PATH).where('is_deleted','==',false).get();
        data.docs.forEach(doc => {
            let client = new Clients(doc.data());
            clients.push(client);
        });
        return clients;
    }
}
